type BrandLogoKey = 'tend' | 'zenith';

type BrandLogoConfig = {
  alt: string;
  className: string;
  src: string;
};

export const brandLogos: Record<BrandLogoKey, BrandLogoConfig> = {
  tend: {
    alt: 'Tend',
    className: 'tend-text-image',
    src: 'https://ucarecdn.com/2d8cfae6-6217-4209-aa15-240451327892/TendLetters.svg',
  },
  zenith: {
    alt: 'Zenith',
    className: 'zenith-image',
    src: 'https://ucarecdn.com/a403fdf5-ba34-42da-b917-ebc0bdf419a9/ZenithWhite.svg',
  },
};

function getLogoConfig(value: string | undefined): BrandLogoConfig | null {
  if (value !== 'tend' && value !== 'zenith') {
    return null;
  }

  return brandLogos[value];
}

export function mountHeaderBrandLogos(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>('[data-brand-logo]').forEach((logoSlot) => {
    const logoConfig = getLogoConfig(logoSlot.dataset.brandLogo);

    if (logoConfig == null) {
      return;
    }

    const logoImage = document.createElement('img');
    logoImage.alt = logoConfig.alt;
    logoImage.className = logoConfig.className;
    logoImage.decoding = 'async';
    logoImage.src = logoConfig.src;

    logoSlot.setAttribute('aria-label', logoConfig.alt);
    logoSlot.replaceChildren(logoImage);
  });
}
